import { usePopoverPortalContext } from "@circle-react-uikit/PopoverPortal";
import { Typography } from "@circle-react-uikit/Typography";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { Link } from "@tanstack/react-router";
import { isFunction } from "lodash";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";
import { useSmOrMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";

import { IconButton } from "../../IconButton";
import { NotificationFilter } from "./Filter";
import { MarkAsReadButton } from "./MarkAsReadButton";
import { NotificationSettingsButton } from "./NotificationSettingsButton";

interface HeaderProps {
  onClose?: () => void;
}

export const Header = ({ onClose }: HeaderProps) => {
  const isSmallScreen = useSmOrMdScreenMediaQuery();
  const { onClose: closePopover } = usePopoverPortalContext();
  const { currentCommunitySettings } = usePunditUserContext();
  const isNotificationsTabV2Enabled = Boolean(
    currentCommunitySettings?.live_pulse_notifications_tab_v2_enabled,
  );

  return (
    <div className="flex items-center justify-between px-6 pb-2 pt-5">
      <Typography.LabelLg weight="medium">
        {t("header_v3.notifications")}
      </Typography.LabelLg>
      <div className="flex items-center space-x-2">
        {isNotificationsTabV2Enabled && <NotificationFilter />}
        <MarkAsReadButton />
        {!isSmallScreen && (
          <TippyV2
            interactive={false}
            content={t("header_v3.open_in_full_page")}
          >
            <Link to="/notifications" onClick={() => closePopover?.()}>
              <IconButton
                name="16-square-arrow-top-right"
                iconSize={20}
                ariaLabel={t("header_v3.open_in_full_page")}
                iconClassName="!text-dark"
              />
            </Link>
          </TippyV2>
        )}
        <NotificationSettingsButton />
        {isFunction(onClose) && (
          <TippyV2 interactive={false} content={t("header_v3.close")}>
            <IconButton
              name="16-close"
              ariaLabel={t("header_v3.close")}
              onClick={onClose}
              iconClassName="!text-dark !h-5 !w-5"
              className="!p-0"
            />
          </TippyV2>
        )}
      </div>
    </div>
  );
};
